import { useMutation, useQueryClient } from '@tanstack/react-query'

import { request } from '../../../lib/axios'
import { useUserStore } from 'Stores/userStoreModuleFed'

export const deleteMicrosoftAudience = async (accountId: string, audienceId: string | number) => {
  return await request({
    url: `/accounts/${accountId}/audiences/bing/${audienceId}`,
    method: 'DELETE',
  })
}

export const useDeleteMicrosoftAudience = () => {
  const queryClient = useQueryClient()
  const { accountId } = useUserStore()
  return useMutation({
    mutationKey: ['deleteMicrosoftAudiences'],
    mutationFn: ({ audienceId }: { audienceId: number }) =>
      deleteMicrosoftAudience(`${accountId}`, audienceId),
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ['getPlatformsConnections'] })
      await queryClient.invalidateQueries({ queryKey: ['getPlatforms'] })
      await queryClient.invalidateQueries({ queryKey: ['microsoftAudiencesData'] })
    },
  })
}
